import React, { forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import Colors from '../theme/Colors'

function DiscordIcon(props, ref) {

  return (
    <SvgIcon {...props} ref={ref} viewBox="0 0 512 512">
      <svg
        viewBox="0 0 512 512"
      >
        <ellipse
          cx="263.948"
          cy="256.884"
          rx="230.829"
          ry="230.829"
          style={{
            fill: '#fff'
          }}
        />
        <path
          d="m394.584 170.1588c-38.97-27.9666-75.2817-29.1257-82.22-29.2705l-4.4282 4.2021c49.7451 13.9109 73.8057 35.6463 73.8057 35.6463-42.6944-20.6216-82.9351-27.8731-117.794-28.31-34.8584.4367-75.0991 7.6882-117.7934 28.31 0 0 24.06-21.7354 73.8056-35.6463l-4.4287-4.2021c-6.9375.1448-43.25 1.3039-82.2192 29.2705 0 0-43.5454 73.0315-43.5454 162.7271 1.476-1.7391 27.0127 38.5444 92.8476 39.9934 0 0 11.0708-12.3169 19.0415-23.1846-38.3789-10.8679-52.8447-32.6033-52.8447-32.6033 39.9 24.6726 77.167 34.1646 115.1367 32.9314 37.97 1.2332 75.2368-8.2588 115.1367-32.9314 0 0-14.4658 21.7354-52.8447 32.6033 7.9712 10.8677 19.042 23.1846 19.042 23.1846 65.8345-1.449 91.3716-41.7325 92.8472-39.9934.0003-89.6959-43.5447-162.7271-43.5447-162.7271zm-184.2192 134.6157c-16.8276 0-30.4077-13.9109-30.4077-31.01s13.58-31.0095 30.4077-31.0095v.145c16.68 0 30.4082 13.9109 30.4082 31.01 0 16.9536-13.5801 30.8645-30.4082 30.8645zm107.166 0c-16.8276 0-30.4082-13.9109-30.4082-30.8645 0-17.0986 13.728-31.01 30.4082-31.01v-.145c16.8277 0 30.4077 13.9109 30.4077 31.0095s-13.58 31.01-30.4077 31.01z"
          style={{
            fill: Colors.background
          }}
        />
      </svg>

    </SvgIcon>
  )
}

export default forwardRef(DiscordIcon)